import { useState } from 'react';
import { NavLink } from 'react-router-dom';

import HeaderLogo from 'components/Header/HeaderLogo';
import WithScrollHeader from 'hocs/WithScrollHeader';
import {
  handleClassName,
  handleNavClassNames,
  handleMobMenuClassNames,
  links,
  logoClassNames,
} from 'components/Header/constants';

const Header = () => {
  const [isVisibleMenu, setIsVisibleMenu] = useState(false);

  const handleMenu = () => setIsVisibleMenu(!isVisibleMenu);

  return (
    <WithScrollHeader>
      <div className={logoClassNames}>
        <HeaderLogo />
        <nav className={handleNavClassNames(isVisibleMenu)}>
          {links.map(({ to, name }) =>
            <NavLink key={to} to={to} className={handleClassName} onClick={handleMenu}>{name}</NavLink>)}
        </nav>
        <div className={handleMobMenuClassNames(isVisibleMenu)} onClick={handleMenu} />
      </div>
    </WithScrollHeader>
  );
};

export default Header;
